import React from "react";
import styled, { css } from "styled-components";

import { IThemeProps } from "@/styles";

export const withForm =
  <P extends object>(WrappedComponent: React.ComponentType<P>) =>
  (props: P) => (
    <Form>
      <WrappedComponent {...props} />
    </Form>
  );

const Form = styled.form`
  position: relative;
`;

type FormGroupProps = IThemeProps<{ $fieldType?: string }>;
export const FormGroup = styled.div<FormGroupProps>`
  display: flex;
  flex-direction: row;
  justify-content: left;
  margin-bottom: ${(props: FormGroupProps) =>
    props.$fieldType === "radio" ? 0 : props.theme.spacing.desktop.s200}px;
  label {
    margin-right: ${(props: FormGroupProps) =>
      props.theme.spacing.desktop.s500}px;
    &:last-child {
      margin-right: 0;
    }
  }
  @media ${(props: FormGroupProps) => props.theme.breakpoints.mobile} {
    ${(props: FormGroupProps) =>
      props.$fieldType === "radio"
        ? `flex-direction: row;`
        : `flex-direction: column;
                    label {
                        margin-right: 0;
                    }`}
  }
`;

type FormStaticProps = IThemeProps<{
  $variant?:
    | "autofillRegisteredIntro"
    | "autofillEntrySummary"
    | "autofillEditDisclosure";
}>;

export const FormStatic = styled.div<FormStaticProps>`
  flex: none;
  font-size: ${(props: FormStaticProps) => props.theme.typography.h200};
  line-height: ${(props: FormStaticProps) => props.theme.typography.h700};
  width: 100%;
  a {
    font-weight: 600;
  }

  ${(props: FormStaticProps) =>
    props.$variant === "autofillRegisteredIntro" &&
    css`
      color: ${props.theme.colors.fontText};

      > div {
        color: ${props.theme.colors.fontTextSemiLight};
        font-size: ${props.theme.typography.h400};
        font-weight: 400;
        margin-top: ${props.theme.spacing.mobile.s200}px;
      }
    `}

  ${(props: FormStaticProps) =>
    props.$variant === "autofillEntrySummary" &&
    css`
      background-color: ${props.theme.colors.inputBackground};
      border-left: 4px solid ${props.theme.colors.primary};
      border-radius: ${props.theme.borders.borderRadius};
      box-shadow: ${props.theme.shadows.s100};
      color: ${props.theme.colors.fontText};
      margin-top: ${props.theme.spacing.desktop.s300}px;
      max-width: 100%;
      overflow-wrap: anywhere;
      padding: ${props.theme.spacing.desktop.s300}px
        ${props.theme.spacing.desktop.s500}px;

      > div:first-child {
        color: ${props.theme.colors.fontTextSemiLight};
        font-size: ${props.theme.typography.h300};
        font-weight: ${props.theme.globals.fontWeightBold};
        letter-spacing: 0.08em;
        line-height: 1.35;
        margin-bottom: ${props.theme.spacing.mobile.s200}px;
        text-transform: uppercase;
      }

      > div:last-child {
        color: ${props.theme.colors.fontText};
        font-size: ${props.theme.typography.h500};
        font-weight: ${props.theme.globals.fontWeightBold};
        line-height: 1.4;
        overflow-wrap: anywhere;
      }
    `}

  ${(props: FormStaticProps) =>
    props.$variant === "autofillEditDisclosure" &&
    css`
      color: ${props.theme.colors.fontTextSemiLight};
      margin: ${props.theme.spacing.desktop.s400}px 0
        ${props.theme.spacing.desktop.s200}px;
      max-width: 100%;
      overflow-wrap: anywhere;

      > div:first-child {
        font-size: ${props.theme.typography.h400};
        font-weight: ${props.theme.globals.fontWeightBold};
        line-height: 1.35;
        margin-bottom: ${props.theme.spacing.mobile.s200}px;
      }

      > div:last-child {
        font-size: ${props.theme.typography.h300};
        line-height: 1.4;
      }
    `}
`;
